import { updateGifteeBoxTemplateBrandFilter } from '@console/actions/actions';
import { getGifteeBoxTemplateBrandsThunk } from '@console/actions/thunks/getGifteeBoxTemplateBrands';
import type {
  AppThunkAction,
  AppThunkDispatch
} from '@console/actions/thunkType';
import BrandFiltering from '@console/components/common/gifteeBoxTemplateContentSelectionsModal/filteringSection/BrandFiltering';
import type { AppState } from '@console/reducers';
import { getContentSelectionsFilteringBrandUrlCodes } from '@console/selectors/getSearchInfo';
import { getSelectedGifteeBoxTemplateFilteredBrands } from '@console/selectors/getSelectedGifteeBoxTemplate';
import { connect } from 'react-redux';

const getGifteeBoxTemplateBrands =
  (gifteeBoxTemplateUrlCode: UrlCode): AppThunkAction<void> =>
  dispatch => {
    dispatch(getGifteeBoxTemplateBrandsThunk(gifteeBoxTemplateUrlCode)).catch(
      () => {}
    );
  };

const mapStateToProps = (state: AppState) => ({
  selectedGifteeBoxTemplateBrands: state.selectedGifteeBoxTemplate.brands,
  selectedGifteeBoxTemplateUrlCode: state.selectedGifteeBoxTemplate.urlCode,
  selectedBrandUrlCodes: getContentSelectionsFilteringBrandUrlCodes(state),
  selectedBrands: getSelectedGifteeBoxTemplateFilteredBrands(state)
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  getGifteeBoxTemplateBrands: (gifteeBoxTemplateUrlCode: UrlCode) =>
    dispatch(getGifteeBoxTemplateBrands(gifteeBoxTemplateUrlCode)),
  handleBrandFilterChange: value =>
    dispatch(updateGifteeBoxTemplateBrandFilter(value))
});

export type BrandFilteringPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;
export type BrandFilteringPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(BrandFiltering);
